import Config from 'config';

const slug = /:slug/igm;

/**
 * Creates a URL with slug or id replacement
 * @param {String} url 
 * @param {Object} model 
 */
export function linkTo(url = '', model = {}) {
  const base = url.startsWith(Config.app.basePath) ? '' : Config.app.basePath;
  const separator = url[0] === '/' ? '' : '/';

  if (slug.test(url)) {
    return `${base}${separator}${url.replace(slug, model.slug || model.id)}`;
  }

  return `${base}${separator}${url}`;
}
